// ** Amplify
import { API } from "aws-amplify"
import moment from "moment"
// **  store names
import { STORES } from "@constants/redux"

// ** main app Logger
import { appLogger } from "@helpers/logger"
import { handleApiAuthError } from "@helpers/authSession"
import { adminsApiGet } from "@helpers/adminsApiClient"

// ** constants
import { globalConst } from "@constants/global"

const shouldSkipProtectedDashboardCalls = () => {
  // Server-authoritative admin dashboard: disable local fallback mode.
  return false
}

/** initla state for auth store  */
const initialState = {
  data: [],
  analytics: {
    accounts: 0,
    transactions: 0,
    bids: 0,
    auctions: 0
  },
  last_update_analytic_time:null,
  total: {},
  bidAgregate: {},
  perPageValues: [5, 10, 25, 50],
  itemPerPage: 5,
  message: "",
  keyword: null,
  action: globalConst.action.NONE
}

export const analytics = {
  state: initialState,

  reducers: {
    /**
     * Set translate message
     *
     * @param {*} s
     * @param {*} payload
     * @returns
     */
    setMessage: (s, payload) => {
      return {
        ...s,
        message: payload
      }
    },
    setLastUpdateAnalyticTime: (s, payload) => {
      return {
        ...s,
        last_update_analytic_time: payload
      }
    },
    /**
     *
     * @param {*} s
     * @param {*} payload
     * @returns
     */
    setData: (s, payload) => {
      return {
        ...s,
        data: payload
      }
    },
    /**
     *
     * @param {*} s
     * @param {*} payload
     * @returns
     */
    setBidagregate: (s, payload) => {
      return {
        ...s,
        bidAgregate: payload
      }
    },
    /**
     *
     * @param {*} s
     * @param {*} payload
     * @returns
     */
    setAnalytics: (s, payload) => {
      return {
        ...s,
        analytics: payload
      }
    },
    /**
     *
     * @param {*} s
     * @param {*} payload
     * @returns
     */
    setTotal: (s, payload) => {
      return {
        ...s,
        total: payload
      }
    },
    /**
     *
     * @param {*} s
     * @param {*} payload
     * @returns
     */
    pushNewData: (s, payload) => {
    
      return {
        ...s,
        data: [...s.data, payload]
      }
    },
    /**
     *
     * @param {*} s
     * @param {*} payload
     * @returns
     */
    setFilters: (s, payload) => {
    
      return {
        ...s,
        filters: { ...s.filters, ...payload }
      }
    },
    /**
     *
     * @param {*} s
     * @param {*} payload
     * @returns
     */
    setKeyword: (s, payload) => {
      return {
        ...s,
        keyword: payload
      }
    },
    /**
     *
     * @param {*} s
     * @param {*} payload
     * @returns
     */
    setitemPerPage: (s, payload) => {
      return {
        ...s,
        itemPerPage: payload
      }
    },
    /**
     *
     * @param {*} s
     * @param {*} payload
     * @returns
     */
    setCurrent: (s, payload) => {
      return {
        ...s,
        current: payload
      }
    },

    /**
     *
     * @param {*} s
     * @param {*} payload
     * @returns
     */
    setAction: (s, payload) => {
      return {
        ...s,
        action: payload
      }
    }
  },
  selectors: (slice, createSelector) => ({
    /**
     *
     * @returns
     */
    error() {
      return createSelector(
        [slice, (rootState) => rootState.loading.models.stuffs],
        (stuffs, stuffsLoading) => {
          return stuffsLoading.error || ""
        }
      )
    },
    lastUpdateAnalyticTime(){
      return createSelector(
        [slice],
        (analytics)=>analytics.last_update_analytic_time
      )
    },
    analytics(){
      return createSelector(
        [slice],
        (analytics)=>analytics.analytics
      )
    },

    /**
     * success selector used in different
     * auth actions
     *
     * @returns {String}
     */
    success() {
      return createSelector(
        [slice, (rootState) => rootState.loading.models.auctions],
        (auctions, auctionsLoading) => auctionsLoading.success
      )
    }
  }),
  effects: (dispatch) => ({
    /**
     *
     */
    async fetchBidagregate() {
      appLogger.info("fetchBidagregate", `[REDUX][${STORES.ANALYTICS}]`)
      this.setAction(globalConst.action.FETCH_BIDAGREGATE)
      try {
        const date = moment().format("MM-DD-YYYY")
      
        const {
          data: { getAgregateBid }
        } = await API.graphql({
          query: `
            query FetchAgregateBids($date: String!) {
                getAgregateBid(dateId: $date) {
                  date
                  totalbids
                }
              }`,
          variables: {
            date
          }
        })
        this.setBidagregate(getAgregateBid)
      } catch (error) {
      
        throw new Error(error)
      }
    },
    /**
     *
     */
    async fetchAnalytics() {
      appLogger.info("fetchAnalytics", `[REDUX][${STORES.ANALYTICS}]`)
      this.setAction(globalConst.action.FETCH_ANALYTICS)
      if (shouldSkipProtectedDashboardCalls()) {
        this.setLastUpdateAnalyticTime(new Date())
        this.setAnalytics({
          accounts: 0,
          transactions: 0,
          bids: 0,
          auctions: 0
        })
        this.setAction(globalConst.action.NONE)
        return
      }
      try {
      
        // When using local development with /commons in base URL, 
        // we should NOT add /commons to the endpoint path
        const result = await adminsApiGet(`/analytics/v1/`)
        this.setLastUpdateAnalyticTime(new Date())
        this.setAnalytics(result)
        this.setAction(globalConst.action.NONE)
      } catch (error) {
        if (handleApiAuthError(error)) return
        this.setAction(globalConst.action.NONE)
        this.setAnalytics({
          accounts: 0,
          transactions: 0,
          bids: 0,
          auctions: 0
        })
      }
    },
    async fetchTotalAnalytics() {
      appLogger.info("fetchTotalAnalytics", `[REDUX][${STORES.ANALYTICS}]`)
      this.setAction(globalConst.action.FETCH_TOTAL_ANALYTICS)
      try {
        const date = "all"
     
        const {
          data: { getAnalytic }
        } = await API.graphql({
          query: `
              query FetchAnalytics($id: String!) {
                getAnalytic(id: $id) {
                    id
                    totalAccounts
                    totalAuctions
                    totalInsurance
                    sumInsurance
                  }
                }`,
          variables: {
            id: date
          }
        })
     
        this.setTotal(getAnalytic)
      } catch (error) {
        throw new Error(error)
      }
    },
    /**
     *
     * @param {*} payload
     */
    async onBidAgregateChanged(payload) {
      this.setBidagregate(payload)
    },
    /**
     *
     * @param {*} payload
     */
    async onanalyticsChanged(payload) {
      this.setAnalytics(payload)
    }
  })
}
